import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { ChronoRecap } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoRecap"
import {
  type ExerciseFormikType,
  type ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"
import { PlusIcon } from "lucide-react"

export function ExerciseChronoInput({
  formik,
  openChronoForm,
  className,
  ...props
}: {
  formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey>
  openChronoForm: () => void
} & React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "mb-0 flex w-full",
        formik.values.chronoType && formik.values.chronoType !== "NONE" ? "flex-col" : "",
        className,
      )}
      {...props}
    >
      {formik.values.chronoType && formik.values.chronoType !== "NONE" ? (
        <ChronoRecap formik={formik} />
      ) : (
        <div className="flex w-full flex-row items-center justify-start gap-3 rounded-2xl bg-surface-foreground px-5 py-6">
          <div
            onClick={() => void openChronoForm()}
            className="transition-duration-300 flex cursor-pointer items-center justify-center rounded-full bg-neutral-200 transition-all hover:bg-neutral-300"
            style={{ height: 40, width: 40 }}
          >
            <PlusIcon color="currentColor" className="text-textDefault-body" size={24} strokeWidth={1} />
          </div>
          <div className="flex flex-col items-start gap-1">
            <Text className="font-bold" fontStyle="LL">
              {word("program.planning.create.exercise.addChrono.title")}
            </Text>
            <Text className="text-textDefault-caption" fontStyle="BS">
              {word("program.planning.create.exercise.addChrono.description")}
            </Text>
          </div>
        </div>
      )}
    </div>
  )
}
